module.exports = __webpack_public_path__ + "static/semantic-card-link-6b0e11a9d31c7409a54a3a3dcae54039.gif";